/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 122:
/***/ (function() {

function initAnchorDisclosure() {
  const productEl = document.querySelector('.js-product');
  if (!productEl || productEl.dataset.anchorDisclosureInit === 'true') return;
  productEl.dataset.anchorDisclosureInit = 'true';
  productEl.addEventListener('click', evt => {
    const trigger = evt.target.closest('[data-open-disclosure]');
    if (!trigger) return;
    if (!trigger.closest('[data-product-description]')) return;
    const targetId = trigger.dataset.openDisclosure;
    const targetDisclosure = document.getElementById(targetId);
    if (!targetDisclosure || typeof targetDisclosure.open !== 'function') {
      return;
    }
    evt.preventDefault();
    targetDisclosure.open();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = targetDisclosure.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          behavior: 'smooth',
          top
        });
      });
    });
  });
}
initAnchorDisclosure();
document.addEventListener('product:page-swapped', initAnchorDisclosure);

/***/ }),

/***/ 320:
/***/ (function() {

function initGhostVariant() {
  const productEl = document.querySelector('.js-product');
  if (!productEl || productEl.dataset.ghostVariantInit === 'true') return;
  productEl.dataset.ghostVariantInit = 'true';
  productEl.addEventListener('on:variant:change', evt => {
    const isGhostVariant = evt.detail.variant === null;
    productEl.toggleAttribute('data-ghost-variant', isGhostVariant);
  });
}
initGhostVariant();
document.addEventListener('product:page-swapped', initGhostVariant);

/***/ }),

/***/ 864:
/***/ (function() {

const DISMISSED_CLASS = 'zajo-nav-dismissed';
function getNav() {
  return document.querySelector('page-header .multi-level-nav');
}
function closeMenus() {
  let {
    restoreFocus = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const nav = getNav();
  if (!nav) return;
  const expanded = nav.querySelectorAll('[aria-expanded="true"]');
  const megaMenu = nav.querySelector('#mega-menu-tier-2');
  const hoveredParent = nav.querySelector('.tier-1 > ul > li.contains-children:hover');
  if (!expanded.length && !hoveredParent) return;
  const pageHeader = nav.closest('page-header');
  if (pageHeader) clearTimeout(pageHeader.closeMenuTimeout);
  expanded.forEach(el => el.setAttribute('aria-expanded', false));
  if (megaMenu) megaMenu.classList.remove('tier-appeared');
  if (hoveredParent) hoveredParent.classList.add(DISMISSED_CLASS);
  if (restoreFocus && expanded[0] && nav.contains(document.activeElement)) {
    expanded[0].focus();
  }
}
function initMegaMenuDismiss() {
  const nav = getNav();
  if (!nav || nav.dataset.dismissInit === 'true') return;
  nav.dataset.dismissInit = 'true';
  document.addEventListener('keydown', evt => {
    if (evt.key === 'Escape') closeMenus({
      restoreFocus: true
    });
  });
  document.addEventListener('pointerdown', evt => {
    if (!nav.contains(evt.target)) closeMenus();
  });
  nav.addEventListener('focusout', evt => {
    if (evt.relatedTarget) {
      if (!nav.contains(evt.relatedTarget)) closeMenus();
      return;
    }
    requestAnimationFrame(() => {
      if (!nav.contains(document.activeElement) && !nav.matches(':hover')) {
        closeMenus();
      }
    });
  });
  const parents = nav.querySelectorAll('.tier-1 > ul > li.contains-children');
  parents.forEach(li => {
    li.addEventListener('mouseleave', () => {
      li.classList.remove(DISMISSED_CLASS);
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenuDismiss);
} else {
  initMegaMenuDismiss();
}

/***/ }),

/***/ 408:
/***/ (function() {

document.addEventListener('DOMContentLoaded', function () {
  initProductAsVariants();
});
window.addEventListener('popstate', function () {
  changeProductSelection(window.location.href, false);
});
function initProductAsVariants() {
  initVariantLinks();
  initVariantSelects();
}
function initVariantLinks() {
  document.querySelectorAll('[data-id="product-as-variant-link"]').forEach(function (linkElement) {
    if (linkElement.dataset.variantLinkInitialized === 'true') return;
    linkElement.dataset.variantLinkInitialized = 'true';
    linkElement.addEventListener('click', function (event) {
      event.preventDefault();
      switchProduct(linkElement);
    });
  });
}
let variantSelectGlobalBound = false;
function initVariantSelects() {
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    if (select.dataset.variantSelectInitialized === 'true') return;
    const trigger = select.querySelector('[data-variant-select-trigger]');
    const menu = select.querySelector('[data-variant-select-menu]');
    const options = select.querySelectorAll('[data-variant-select-option]');
    if (!trigger || !menu) return;
    select.dataset.variantSelectInitialized = 'true';
    trigger.addEventListener('click', function () {
      setSelectOpen(select, !select.classList.contains('is-open'));
    });
    options.forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        const url = option.getAttribute('data-url');
        setSelectOpen(select, false);
        if (url) changeProductSelection(url);
      });
    });
  });
  if (!variantSelectGlobalBound) {
    variantSelectGlobalBound = true;
    document.addEventListener('click', handleVariantSelectOutsideClick);
    document.addEventListener('keydown', handleVariantSelectKeydown);
  }
}
function handleVariantSelectOutsideClick(event) {
  if (event.target.closest('[data-variant-select]')) return;
  document.querySelectorAll('[data-variant-select].is-open').forEach(function (select) {
    setSelectOpen(select, false);
  });
}
function handleVariantSelectKeydown(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-variant-select].is-open').forEach(function (select) {
    setSelectOpen(select, false);
  });
}
function setSelectOpen(select, isOpen) {
  const trigger = select.querySelector('[data-variant-select-trigger]');
  const menu = select.querySelector('[data-variant-select-menu]');
  select.classList.toggle('is-open', isOpen);
  if (menu) menu.hidden = !isOpen;
  if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}
let productAsVariantsAbortController = null;
async function changeProductSelection(productLink, pushState) {
  if (productAsVariantsAbortController) {
    productAsVariantsAbortController.abort();
  }
  const controller = new AbortController();
  productAsVariantsAbortController = controller;
  const signal = controller.signal;
  if (pushState === undefined) pushState = true;
  const loading = document.getElementById('product-as-variants-loading');
  if (loading) loading.classList.add('is-active');
  const timeoutId = setTimeout(function () {
    controller.abort();
  }, 10000);
  try {
    const response = await fetch(productLink, {
      signal
    });
    if (!response.ok) throw new Error('HTTP ' + response.status);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newMain = doc.querySelector('main#main-content');
    const oldMain = document.querySelector('main#main-content');
    if (!newMain || !oldMain) throw new Error('Could not find #main-content');
    Array.from(oldMain.attributes).forEach(function (attr) {
      oldMain.removeAttribute(attr.name);
    });
    Array.from(newMain.attributes).forEach(function (attr) {
      oldMain.setAttribute(attr.name, attr.value);
    });
    oldMain.innerHTML = newMain.innerHTML;
    document.dispatchEvent(new CustomEvent('product:page-swapped', {
      detail: {
        html,
        productLink
      }
    }));
    updateSEO(doc, productLink);
    if (pushState) {
      window.history.pushState({}, '', productLink);
    }
    const wrapper = document.querySelector('#product-as-variants');
    if (wrapper && wrapper.dataset.scrollToTopOnVariantChange === 'true') {
      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    initProductAsVariants();
  } catch (error) {
    if (error.name === 'AbortError') {
      if (productAsVariantsAbortController !== controller) return;
      location.href = productLink;
      return;
    }
    console.error('Error loading product variant:', error);
    setTimeout(function () {
      if (!signal.aborted) location.href = productLink;
    }, 1500);
  } finally {
    clearTimeout(timeoutId);
    if (productAsVariantsAbortController === controller) {
      const loadingElement = document.getElementById('product-as-variants-loading');
      if (loadingElement) loadingElement.classList.remove('is-active');
    }
  }
}
function updateSEO(doc, productLink) {
  const newTitle = doc.querySelector('title');
  if (newTitle) document.title = newTitle.textContent;
  const metaUpdates = [{
    selector: 'meta[name="description"]',
    attr: 'content'
  }, {
    selector: 'meta[property="og:title"]',
    attr: 'content'
  }, {
    selector: 'meta[property="og:description"]',
    attr: 'content'
  }, {
    selector: 'meta[property="og:image"]',
    attr: 'content'
  }, {
    selector: 'meta[property="og:url"]',
    attr: 'content'
  }, {
    selector: 'meta[property="og:type"]',
    attr: 'content'
  }, {
    selector: 'meta[name="twitter:title"]',
    attr: 'content'
  }, {
    selector: 'meta[name="twitter:description"]',
    attr: 'content'
  }, {
    selector: 'meta[name="twitter:image"]',
    attr: 'content'
  }, {
    selector: 'link[rel="canonical"]',
    attr: 'href'
  }];
  metaUpdates.forEach(function (_ref) {
    let {
      selector,
      attr
    } = _ref;
    const newElement = doc.querySelector(selector);
    const currentElement = document.querySelector(selector);
    if (newElement && currentElement) {
      currentElement.setAttribute(attr, newElement.getAttribute(attr));
    } else if (newElement && !currentElement) {
      document.head.appendChild(document.importNode(newElement, true));
    } else if (!newElement && currentElement) {
      currentElement.remove();
    }
  });
  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) ogUrl.setAttribute('content', productLink);
}
function switchProduct(optionElement) {
  if (optionElement.getAttribute('aria-selected') !== 'true') {
    changeProductSelection(optionElement.getAttribute('href'));
  }
}

/***/ }),

/***/ 394:
/***/ (function() {

function previewCardVariantImage(card, imageUrl) {
  card.querySelectorAll('.card__main-image, .card__hover-image').forEach(function (img) {
    if (img.dataset.pcvOrigSrc === undefined) {
      img.dataset.pcvOrigSrc = img.getAttribute('src') || '';
      img.dataset.pcvOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', imageUrl);
  });
}
function restoreCardVariantImage(card) {
  card.querySelectorAll('.card__main-image, .card__hover-image').forEach(function (img) {
    if (img.dataset.pcvOrigSrc === undefined) return;
    if (img.dataset.pcvOrigSrcset) {
      img.setAttribute('srcset', img.dataset.pcvOrigSrcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', img.dataset.pcvOrigSrc);
    delete img.dataset.pcvOrigSrc;
    delete img.dataset.pcvOrigSrcset;
  });
}
document.addEventListener('mouseover', function (event) {
  const swatch = event.target.closest('.product-card-variants__swatch');
  if (!swatch || !swatch.dataset.variantImage) return;
  const card = swatch.closest('product-card, .card');
  if (card) previewCardVariantImage(card, swatch.dataset.variantImage);
});
document.addEventListener('mouseout', function (event) {
  const row = event.target.closest('.product-card-variants');
  if (!row || row.contains(event.relatedTarget)) return;
  const card = row.closest('product-card, .card');
  if (card) restoreCardVariantImage(card);
});

/***/ }),

/***/ 853:
/***/ (function() {

document.addEventListener('DOMContentLoaded', initAllMediaGallery);
document.addEventListener('product:page-swapped', initAllMediaGallery);
function initAllMediaGallery() {
  const gridGalleries = document.querySelectorAll('media-gallery[data-layout="grid"]');
  gridGalleries.forEach(galleryElement => {
    if (galleryElement.dataset.zajoGalleryInit === 'true') return;
    galleryElement.dataset.zajoGalleryInit = 'true';
    initMediaGalleryShowMore(galleryElement);
    initMediaScrollIndicator(galleryElement);
  });
}
function initMediaGalleryShowMore(galleryElement) {
  const showMoreButton = galleryElement.querySelector('[data-gallery-show-more]');
  if (!showMoreButton) return;
  showMoreButton.addEventListener('click', () => {
    const isCurrentlyExpanded = galleryElement.classList.contains('is-expanded');
    galleryElement.classList.toggle('is-expanded', !isCurrentlyExpanded);
    showMoreButton.setAttribute('aria-expanded', String(!isCurrentlyExpanded));
    showMoreButton.textContent = isCurrentlyExpanded ? showMoreButton.dataset.showLabel : showMoreButton.dataset.hideLabel;
    if (isCurrentlyExpanded && showMoreButton.dataset.scrollToTop === 'true') {
      galleryElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
}
function initMediaScrollIndicator(galleryElement) {
  const viewer = galleryElement.querySelector('[data-media-viewer]');
  const viewerWrapper = galleryElement.querySelector('[data-media-gallery-viewer]');
  if (!viewer || !viewerWrapper) return;
  const indicator = document.createElement('div');
  indicator.className = 'media-scroll-indicator';
  const thumb = document.createElement('div');
  thumb.className = 'media-scroll-indicator__thumb';
  indicator.appendChild(thumb);
  viewerWrapper.appendChild(indicator);
  function updateThumb() {
    const scrollableWidth = viewer.scrollWidth - viewer.clientWidth;
    if (scrollableWidth <= 0) {
      indicator.style.display = 'none';
      return;
    }
    indicator.style.display = '';
    const trackWidth = indicator.clientWidth;
    const thumbWidth = Math.round(viewer.clientWidth / viewer.scrollWidth * trackWidth);
    const thumbLeft = Math.round(viewer.scrollLeft / scrollableWidth * (trackWidth - thumbWidth));
    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${thumbLeft}px)`;
  }
  viewer.addEventListener('scroll', updateThumb, {
    passive: true
  });
  window.addEventListener('resize', updateThumb);
  updateThumb();
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _partials_anchor_disclosure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(122);
/* harmony import */ var _partials_anchor_disclosure__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_partials_anchor_disclosure__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _partials_mega_menu_dismiss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(864);
/* harmony import */ var _partials_mega_menu_dismiss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_partials_mega_menu_dismiss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _partials_ghost_variant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(320);
/* harmony import */ var _partials_ghost_variant__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_partials_ghost_variant__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _partials_product_as_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(408);
/* harmony import */ var _partials_product_as_variants__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_partials_product_as_variants__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _partials_product_card_variant_preview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(394);
/* harmony import */ var _partials_product_card_variant_preview__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_partials_product_card_variant_preview__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sections_zajo_media_gallery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(853);
/* harmony import */ var _sections_zajo_media_gallery__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_sections_zajo_media_gallery__WEBPACK_IMPORTED_MODULE_5__);








}();
/******/ })()
;